import "./Footer.css";

const Footer = () => {
  const date = new Date();
  return (
    <footer>
      <div className="stage">
        <div className="marquee">
          <span>
           Married Public Figure Leaked Intimate Content
          </span>
          <span>
            
           Married Public Figure Leaked Intimate Content
          </span>
          <span>
            
           In a shocking turn of events Doug Butler working at Oakland Hot Springs Married and a father has come under intense scrutiny allegedly leaking his private intimate videos and photos on various social media platforms.
          </span>
        </div>
      </div>
      <ul>
        <li>Arkansas news</li>
        <li>copyright &copy;{date.getFullYear()}</li>
      </ul>

      <p>
        <a href="#">Back to top</a>
      </p>
    </footer>
  );
};

export default Footer;
